<template>
<div class="common-store-list">
  <div class="ui-storelist-filter">
    <ul class="filter-list">
      <li class="item"
          v-for='(item, index) in sortkey'
          v-bind:key='item.id'
          v-on:click='setActiveSortkey(item, index)'
          v-bind:class="{'sortactive': item.id == currentSortKey.id, 'sortnormal' : item.id != currentSortKey.id}">
        <a v-if='!item.isMore'>{{item.name}}</a>
        <a v-else>{{sort.name}}</a>
        <!-- <span class="iconfont" :class="isShowMore?'active':''" v-if="item.isMore">&#xe6ea;</span> -->
		    <div class='tabbar-indicator'></div>
      </li>
    </ul>
    <div class="sort-model" v-if='isShowMore' >
      <div v-for='(item, index) in childSort' v-bind:key='item.id' v-on:click='getSortChild(item)' v-bind:class="{'active': item.id == sort.id}">
        <a>{{item.name}}</a>
        <span class="iconfont" v-if="item.id == sort.id">&#xe69b;</span>
      </div>
  </div>
  </div>
  <div class="storelist-body show-store-list">
    <!-- 无限加载滚动列表 -->
    <div class="flex-wrapper" v-infinite-scroll="getMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
      <div class="ui-product-body"
           v-for='(item, index) in storeList'
           v-bind:key='index'
      >
        <div class="list-wrapper" v-on:click='goDetail(item.store_id)'>
          <div class="list">
            <div class="ui-image-wrapper">
              <img class="product-img" v-lazy="item.store_avatar">
              <div v-if="!item.is_open" class="store-not-open-mask">
                  <div class="store-not-open-content">
                    <div class="store-not-open-text">目前未營業</div>
                      <div style="padding:0 .2rem">
                      <div class="reservation-order-text">預約訂單</div>
                    </div>
                  </div>
              </div>
            </div>

            <div class="flex-right">
              <div class="product-header">
                <h3 class="title clear-bottom" style="-webkit-box-orient:vertical">{{ item.store_name }}</h3>
                <div style="font-size: .8rem;
                  font-weight: bold;
                  display: flex;
                  align-items: center;
                  justify-content: center;">
                  <img src="@/assets/image/member/star.png" style="width: 15px; padding-right: 6px; padding-bottom: 4px;">{{ creditText(item) }}
                </div>
                <div style="display: flex;
                  justify-content: space-between;
                  font-size: .5rem;
                  width: 100%;
                  letter-spacing: .4px;
                  color: #808080;
                  overflow: hidden">
                  <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ utils.addressFormatter(item.store_address).road || ''}}</div>
                  <!-- <div style="flex-basis: 50%; text-align: right;">{{ item.distance.toFixed(1) }}{{ $t('general.distance_unit_en') }} | {{ item.store_duration }}{{ $t('general.minute') }}</div> -->
                  <div style="flex-basis: 50%; text-align: right;">{{ item.distance.toFixed(1) }}{{ $t('general.distance_unit_en') }}</div>
                </div>
              </div>
              <!-- <div class="store-info-wrapper">
                <div class="store-info">
                  <div class="sub-title" style="-webkit-box-orient:vertical">
                    <span class="common-score-wrapper"><i class="iconfont front" :style="{width:item.store_credit_percent+'%'}"></i><i class="iconfont back"></i></span>
                    <span class="distance">{{ item.store_o2o_average_time }}{{ $t('general.minute') }}</span>
                  </div> -->
              <!-- <div class="sub-title" style="-webkit-box-orient:vertical">起送￥{{ item.store_o2o_min_cost }}</div> -->
                <!-- </div>
              </div> -->
            </div>
          </div>
          <!-- <div class="goods-list" v-if="item.goods_list && item.goods_list.length">
            <div class="goods-item" v-for="(goods,gindex) in item.goods_list" :key="gindex">
              <div class="goods-image"><img :src="goods.goods_image_url"></div>
              <div class="goods-price">${{ utils.currencyPrice(goods.goods_price) }}</div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="loading-wrapper" v-if="storeList.length > 0">
      <!-- <p class="common-no-more" v-if='!isMore'>没有更多了</p> -->
      <mt-spinner type="triple-bounce" color='#FA800A' v-if='isMore'></mt-spinner>
    </div>
    <empty-record v-if='storeList.length <= 0 && !isMore'></empty-record>
  </div>
</div>
</template>

<script>
import EmptyRecord from '../../EmptyRecord'
import { mapState, mapMutations } from 'vuex'
import { getStoreList } from '../../../api/homesearch'
export default {
  name: 'CommonStoreList',
  props: [],
  components: {
    EmptyRecord
  },
  data () {
    return {
      sortkey: [
        {
          key: '',
          name: this.$t('store_order.general'),
          isMore: false,
          id: 0
        },
        {
          key: 'speed',
          name: this.$t('store_order.speed'),
          isMore: false,
          id: 1
        },
        {
          key: 'score',
          name: this.$t('store_order.score'),
          isMore: false,
          id: 2
        },
        {
          key: 'sale',
          name: this.$t('store_order.sale'),
          isMore: false,
          id: 3
        },
        {
          key: 'distance',
          name: this.$t('store_order.distance'),
          isMore: false,
          id: 4
        }
      ], // 排序数据
      childSort: [], // 综合筛选
      sort: {}, // 综合筛选子集
      isShowMore: false, // 是否显示筛选模态框
      params: {
        brand: this.$route.query.brand ? this.$route.query.brand : '',
        category: this.$route.query.category ? this.$route.query.category : '',
        is_exchange: 0,
        is_hot: 0,
        activity: null, // TODO: 确认activity的值
        sort_key: this.$route.query.sort_key ? this.$route.query.sort_key : '',
        sort_value: 2,
        page: this.$store.state.store.page,
        keyword: this.$route.query.keywords ? this.$route.query.keywords : ''
      },      
      loading: false, // 是否加载更多
    }
  },
  computed: {
    ...mapState({
      member_point: state => state.member.point,
      token: state => state.member.token,
      scrollTop: state => state.store.scrollTop
    }),
    // 店家列表
    storeList: {
      get() {
        return this.$store.state.store.storeList
      },
      set(value) {
        this.setStoreList(value)
      }
    },
    // 非營業時間店家列表
    storeClosedList: {
      get() {
        return this.$store.state.store.closeStoreList
      },
      set(value) {
        this.setCloseStoreList(value)
      }
    },
    // 当前选中的排序
    currentSortKey: {
      get() {
        return this.$store.state.store.currentSortKey
      },
      set(value) {
        this.setCurrentSortKey(value)
      }
    },
    // 是否有更多
    isMore: {
      get() {
        return this.$store.state.store.hasMore
      },
      set(value) {
        this.setHasMore(value)
      }
    }
  },
  created () {
    if (Object.keys(this.currentSortKey).length === 0) {
      this.currentSortKey = this.sortkey[0]
    }
    
    this.childSort = this.currentSortKey.child
    this.sort = !this.childSort? {} : this.childSort[0]
  },
  mounted() {
    this.scroll()
  },
  methods: {
    ...mapMutations({
      setStoreList: 'setStoreList',      
      setCloseStoreList: 'setCloseStoreList',
      setCurrentSortKey: 'setCurrentSortKey',
      setHasMore: 'setHasMore',
      setPage: 'setPage',
      setScrollTop: 'setScrollTop'
    }),
    scroll() {
      if(this.scrollTop) {
        this.$nextTick(() => {
          document.querySelector('#app').scrollTop = this.scrollTop
        })
      }
    },
    creditText(item) {
      if (item.store_credit_count > 0)
        return item.store_desccredit + ' / ' + item.store_credit_count
      else
        return this.$t('store.no_credit')
    },
    // closeFiler: 关闭下拉筛选模态框
    closeFiler () {
      this.isShowMore = false
    },
    // isShowDroupMenu: 点击显示下拉框， 并且显示模态框
    isShowDroupMenu () {
      let item = this.currentSortKey
      if (item.isMore) {
        this.isShowMore = true
      } else {
        this.isShowMore = false
      }
    },
    /**
     *  setActiveSortkey: 点击切换数据并设置选中的样式
     *  @param: item 当前选中的item
     */
    setActiveSortkey (item, index) {
      this.currentSortKey = item
      if (item.isMore) {
        this.isShowMore = !this.isShowMore
      } else {
        this.closeFiler()
        this.getValue()
      }
    },
    /**
     *  getValue: 向父级组件发送改变列表事件， 并传递当前的sort_key， sort_value
     */
    getValue () {
      let data = this.getSortValue()
      let res = data
      this.params.page = 1
      this.storeList = []
      this.storeClosedList = []
      // 為了不讓頁數增加錯誤，必須鎖住不讓scroll觸發getMore
      this.loading = true
      this.setScrollTop(0)
      this.setParamsByData(res)
      this.getStoreList(false)
    },
    /**
     *  getSortValue: 获取排序值
     */
    getSortValue () {
      let sort = this.currentSortKey
      let value = { 'sort_key': '', 'sort_value': '' }
      if (sort.isMore) {
        value.sort_key = this.sort.key
      } else {
        value.sort_key = sort.key
      }
      return value
    },
    /**
     *  getSortChild: 获取综合筛选的子集， 关闭父级的阴影模态框， 关闭子集， 获取列表数据
     *  @param: item 模态框的item
     */
    getSortChild (item) {
      this.sort = item
      this.isShowMore = !this.isShowMore
      this.getValue()
    },
    /*
    * getMore: 无限滚动加载
    */
    getMore () {
      this.loading = true
      if (this.isMore) {
        this.params.page = ++this.params.page
        this.getStoreList(true)
      }
    },
    /**
     * getStoreList: 获取商品列表
     * @param：  ispush ？ true ：false 是否需要向商品列表追加数据
     */
    getStoreList (ispush) {
      let data = this.params
      let member_point = this.member_point
      if (!member_point) {
        // this.$router.push({ name: 'HomeMap' })
        return
      }
      getStoreList(
        data.brand,
        data.category,
        data.keyword,
        member_point.lng,
        member_point.lat,
        data.sort_key,
        data.page,
        this.token
      ).then(res => {
        this.buildData(ispush, res)
      })
    },
    /**
     * getList: 构建数据
     * @param: ispush 是否改变向元数据追加数据
     * @param: res 接口请求返回的数据
     */
    buildData (ispush, res) {
      if (res) {
        if (ispush) {
          this.storeList = this.storeList.concat(res.result.store_list)
        } else {
          this.storeList = res.result.store_list
        }
        for (let idx = 0; idx < this.storeList.length; idx++) {
          if (this.storeList[idx].is_open === false) {
            this.storeClosedList.push(this.storeList.splice(idx, 1)[0])
            idx--
          }
        }
        this.isMore = res.result.hasmore

        if ((this.storeList.length <= 4 && res.result.hasmore)) {
          this.getMore()
          return
        }

        if (res.result.hasmore === false) {
          this.storeList = this.storeList.concat(this.storeClosedList)
          this.storeClosedList = []
        }

        // 由於先前先鎖住不可scroll get more假設結束後還有資料必須再把loading 改為false
        if (res.result.hasmore) {
          this.loading = false
        }
      }
    },
    /**
     * 根据事件传递的值来对请求列表重新赋值
     * @param data 事件传递的参数
     * @returns {params|{brand, category, is_exchange, is_hot, activity, sort_key, sort_value, page, per_page, keyword}}
     */
    setParamsByData (data) {
      let params = this.params
      for (let item in params) {
        for (let list in data) {
          if (item === list) {
            params[item] = data[list]
          }
        }
      }
      return params
    },
    goDetail (store_id) {
      this.setScrollTop(document.querySelector('#app').scrollTop)
      this.setPage(this.params.page)
      this.$router.push({ 'name': 'HomeStoredetail', 'query': { 'id': store_id } })
    }
  }
}
</script>

<style lang='scss' scoped>
  .store-not-open-mask {
    position:absolute;
    width:100%;
    height:100%;
    background:rgba(0,0,0,.6);
    display:flex;
    justify-content:center;
    align-items:center;
    text-align:center;
    border-radius: 20px;
  }

  .store-not-open-content {
    width:70%;
    height:40%;
    display:flex;
    flex-direction:column;
    justify-content:space-between
  }

  .store-not-open-text {
    color:white;
    font-size:.65rem;
    letter-spacing: 0.1em;
  }

  .reservation-order-text {
    background:#F3C41E;
    color:black;
    font-size:.4rem;
    padding:.2rem;
    border-radius: 5px
  }

  .ui-storelist-filter {
    width: auto;
    padding: 0.7rem 0;
    background: #f4c41e;
    // margin-bottom: 8px;
    border-radius: 30px 30px 0 0;
  ul.filter-list{
    display: flex;
    width: auto;
    justify-content: space-around;
    align-content: center;
    align-items: center;
    border: 0;
    // border-bottom: 1px dashed #E8EAED;

  li{
    // background-color: #f4c41e;
    font-size: 0.7rem;
    color: #4E545D;
    // border-bottom: 0.1rem solid transparent;
    position: relative;
    flex-basis: 5rem;
    text-align: center;
    height: 1.6rem;
    padding: 0;
    line-height: 1.9rem;
    z-index: 1;
    // box-shadow: 0px 2px 0px 0px #808080;
    border-radius: 6px;
    letter-spacing: 1px;
    padding-bottom: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
  a {
    color: #4E545D;
    font-weight: bold;
    height: 2.1rem;
    display: inline-block;
  }
  img {
    height: 0.2rem;
    width: 0.4rem;
    vertical-align: middle;
  }
    .iconfont{display: inline-block}
  }
  .sortactive {
    // background-color: #808080;
  }
  li.sortactive {
	  a {
		color:#4A4740;
		font-weight: bold;
	  }
    .iconfont{color:#333;font-weight: bold;}
    .iconfont.active{transform: rotate(180deg);}
	.tabbar-indicator{
		  width: 2.2rem;
      display: block;
      position: absolute;
      // left: 50%;
      // margin-left: -0.8rem;
      bottom: 0;
      height: 2.3px;
      border-radius: 0.5rem;
      z-index: -1;
      background: #6E686C;
		&.right{left:64%}
	}
  }
  li:first-child .tabbar-indicator{
    // left:43%
  }

  li.sortnormal {
    border-bottom-color: transparent;
  a {
    color: #4E545D;
  }
  }
  .arrow-icon {
    width: 0.6rem;
    height: 0.6rem;
  }
  }
  .sort-model {
    position: absolute;
    left: 0;
    width: 100%;
    z-index: 10;
  div {
    color: #4E545D;
    padding: 0.75rem;
    font-size: 0.65rem;
    background-color: #fff;
    margin: 0;
    border-bottom: 1px solid #E8EAED;
    cursor: pointer;
    display: flex;
    width: auto;
    justify-content: space-between;
    align-content: center;
    align-items: center;
  img {
    float: right;
    width: 0.8rem;
    height: 0.8rem;
  }
  &.active {
     color: #FA800A;
   }
  }
  }
  }
  .ui-product-body {

    .goods-list{padding:.8rem .5rem;overflow: hidden;background:#fff;
      .goods-item{float:left;width:25%;text-align: center;
        .goods-image {margin-bottom:.2rem;
          img{width:3.5rem;height: 3.5rem;border-radius:.3rem;}
        }
        .goods-price{color:$primaryColor;font-size:.7rem;white-space: nowrap;overflow: hidden;text-overflow:ellipsis;width:100%}
      }
    }
    .list-wrapper{margin-bottom:.5rem;}
  .list {
    display: flex;
    width: auto;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem;
    position: relative;
    background:#fff;
	box-shadow: 0 .1rem 0.2rem 0 rgba(200,200,200,.4);
  div.ui-image-wrapper {
    // width: 3rem;
    // height: 3rem;
    position: relative;
    border:1px solid #e1e1e1;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-basis: 3rem;
    flex-shrink: 0;
    height: 109px;
    width: 113px;
    border-radius: 20px;

    background-position:center center!important;
    background-size:5rem 5rem;
    background-repeat:no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;

  img.product-img{
    // width: 3rem;
    // height: 3rem;
    height: 109px;
    width: 113px;
    border-radius: 20px;
    flex-basis: 3rem;
    flex-shrink: 0;
	// border-radius:.3rem;
  }


  span {
    position: absolute;
    height:1rem;
    background:rgba(243,244,245,1);
    line-height: 1rem;
    text-align: center;
    font-size:0.7rem;
    color:#FA800A;
    width: 5.5rem;
    bottom: 0;
    left: 0;
  }
  }
  .flex-right {
    // padding-top:.5rem;
    padding-left: 0.7rem;
    width: 100%;
    position:relative;
  .title {
    color: #333333;
    font-size: 0.8rem;
    line-height:1rem;
    // font-weight: bolder;
    font-weight: bold;
    letter-spacing: 1px;
    display:-moz-box;
    display:-webkit-box;

    -webkit-line-clamp: 2;
    -moz-line-clamp: 2;

    -moz-box-orient:vertical;
    -webkit-box-orient:vertical;
    box-orient:vertical;

    overflow: hidden;
    margin-bottom: 0.4rem;
  &.clear-bottom {
     margin-bottom: 0;
   }
  }
  .distance{font-size:.6rem;color:#999;position:absolute;top:1.5rem;right:0;text-align: right}
.store-info-wrapper{display: flex;
  .store-info{flex:1}
  .btn{width:3rem;font-size:.7rem;color:#e1e1e1;text-align: center;border:1px solid #e1e1e1;border-radius:1rem;height: 1rem;line-height: 1rem;}
  .btn.active{border-color:$primaryColor;background:$primaryColor;color:#fff}
}
  .product-header {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
    height: 109px;
    // align-items: center;
  }
  .sub-title {
    color: #666666;
    font-size: .7rem;
    display:-moz-box;
    display:-webkit-box;
    -webkit-line-clamp: 1;
    -moz-line-clamp: 1;
    -moz-box-orient:vertical;
    -webkit-box-orient:vertical;
    box-orient:vertical;

    overflow: hidden;
    margin-bottom: 0.4rem;
  }
  .price {
    margin-bottom: 0.4rem;
  span {
  &:first-child {
     color: #FA800A;
     font-size: 0.8rem;
   }
  &:last-child {
     color: #A4AAB3;
     font-size: 0.6rem;
     text-decoration: line-through;
   }
  }
  }
  .sendway {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.6rem;
    font-weight: 'Regular';
  span{
    color: #999999;
  &.self-support {
     font-size: 0.5rem;
     color: #FA800A;
     border: 1px solid #FA800A;
     border-radius: 0.1rem;
     width: 1.6rem;
     height: 0.8rem;
     line-height: 0.8rem;
     text-align: center;
   }
  }
  }
  }
  }
  }
</style>
